module.exports = __webpack_public_path__ + "img/Logo_Simple_IBRACO_Optimo.cb6cc893.svg";